/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import tabs from '../../../utils/tabs';
import '../styles/LineasProductos.css';

export default function LineasProductos({ onVerCatalogo }) {
  const [activeId, setActiveId] = useState('cardiometabolicos');
  const [selectedMed, setSelectedMed] = useState({});
  const [fadeKey, setFadeKey] = useState(0); // 🔹 clave para forzar animación

  useEffect(() => {
    const tabActual = tabs.find(t => t.id === activeId);
    setSelectedMed(tabActual?.medicamentos?.[0] || {});
    setFadeKey(prev => prev + 1); // 🔹 refresca animación al cambiar tab
  }, [activeId]);

  const handleMedChange = med => {
    setSelectedMed(med);
    setFadeKey(prev => prev + 1); // 🔹 refresca animación al cambiar producto
  };

  return (
    <div className="lp-container">
      <div className="lp-title">Líneas de Productos</div>

      <div className="lp-tabs-wrapper">
        {tabs.map((tab, index) => {
          const isActive = tab.id === activeId;
          // Cuando el tab activo es el primero, los demás van detrás
          // Cuando el tab activo no es el primero, mantiene el orden original
          let zIndex;
          if (isActive) {
            zIndex = 10; // Tab activo siempre al frente
          } else if (activeId === 'cardiometabolicos') {
            // Si cardiometabolicos está activo, los demás van detrás
            zIndex = 1;
          } else {
            // Para otros casos, mantener orden basado en posición
            zIndex = tabs.length - index;
          }

          return (
            <div
              key={tab.id}
              className={`lp-tab ${isActive ? 'active' : ''} ${fadeKey}`} // Añade fadeKey como clase para forzar animación
              style={{
                backgroundColor: tab.bgColor,
                color: tab.textColor,
                zIndex,
              }}
              onClick={() => setActiveId(tab.id)}
            >
              {isActive ? (
                <div
                  key={fadeKey} // 🔹 fuerza re-render con animación
                  className="lp-tab-content"
                  style={{ color: tab.textColor }}
                >
                  <h2 className="lp-tab-heading">• {tab.title}</h2>

                  <div className="lp-content-wrapper">
                    <div className="lp-left-column">
                      {selectedMed?.imagen && (
                        <img
                          src={selectedMed.imagen}
                          alt={selectedMed.product}
                          className="lp-tab-image"
                          loading="lazy"
                        />
                      )}

                      <ul className="lp-medicamentos">
                        {tab.medicamentos.map((med, i) => (
                          <li
                            key={i}
                            className={`lp-med-item ${selectedMed?.product === med.product ? 'active' : ''}`}
                            onClick={e => {
                              e.stopPropagation();
                              handleMedChange(med);
                            }}
                          >
                            {med.product}
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="lp-center-column">
                      <div className="lp-product-name">
                        {selectedMed?.product || 'Selecciona un producto'}
                      </div>

                      {selectedMed?.slug?.trim() && (
                        <div className="lp-product-slug">
                          "{selectedMed.slug}"
                        </div>
                      )}

                      <div className="lp-product-desarr">
                        {selectedMed?.desarr || 'Detalles no disponibles'}
                      </div>
                    </div>

                    <a
                      href="#"
                      className="lp-tab-link"
                      onClick={e => {
                        e.preventDefault();
                        onVerCatalogo?.();
                      }}
                    >
                      Ver catálogo
                    </a>
                  </div>
                </div>
              ) : (
                <div className="lp-tab-label">{tab.title}</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
